export class AdsTypeConstant {
  static readonly FEED_ADS = 'feed-ads';
  static readonly VIDEO_ADS = 'video-ads';
}

export class AdsSubTypeConstant {
  static readonly PINNED = 'pinned';
  static readonly NORMAL = 'normal';
  static readonly APP_BANNER = 'app_banner';
}

export class DisplayViewConstant {
    static readonly APP = 'app';
    static readonly WEB = 'web';
}
